import React, { useState, useEffect, useRef } from 'react';
import { useDS5Controller } from '../hooks/useDS5Controller';
import { useMovementCache } from '../hooks/useMovementCache';
import { api } from '../services/api';
import './RepairStation.css';
import Cadance from './Cadance';
import packageJson from '../../package.json';

const APP_VERSION = packageJson.version;

const REPAIR_MAPPING = {
  "Dismount": {
    "Repair": "Repair",
    "joystick": "Repair Joystick",
    "BER": "BER"
  }
};

const RepairStation = ({ userInfo, userPosition }) => {
  const {
    serialNumber,
    isConnected,
    BoardModel
  } = useDS5Controller();

  const movementsCache = useMovementCache();

  const [warning, setWarning] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [nextJob, setNextJob] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [currentMovementData, setCurrentMovementData] = useState(null);
  const [hasBeenProcessed, setHasBeenProcessed] = useState(false);
  const [selectedRepair, setSelectedRepair] = useState('');
  const [debugInfo, setDebugInfo] = useState('');
  const [Panne, setPanne] = useState('');
  const [date, setdate] = useState('');
  const [selectedRebut, setSelectedRebut] = useState(null);
  const [causeList, setCauseList] = useState([]);
  const [isOpenRebut, setIsOpenRebut] = useState(false);
  const [isOpenRepairModal, setIsOpenRepairModal] = useState(false);
  const [repairPannes, setRepairPannes] = useState([]);
  const [selectedRepairPanneId, setSelectedRepairPanneId] = useState('');
  const [modalError, setModalError] = useState('');
  const [panneId, setPanneId] = useState(null);
  const isCheckingRef = useRef(false);
  const [hourcount, setHourCount] = useState(0);
  const isRepairStation = userPosition === "Dismount";

  const getRebut = async () => {
    if (causeList.length !== 0) return;
    try {
      const Causes = await api.getRebutata();
      
      let rebCause = []
      for (let i = 0; i < Causes.length; i++) {
        rebCause.push(Causes[i].cause)
      }
      console.log(rebCause)
      setCauseList(rebCause);
    }
    catch (err) {
      console.error("Erreur vérification historique:", err);
      setWarning("cannot get cause list ");
    }
    finally {
    }
  };

  const getRepairPannes = async () => {
    try {
      const pannesData = await api.getAllDs5Panne();
      const excludedPannes = ['Rayure légere', 'Grattage léger', 'Rayure profonde', 'Grattage profond'];
      const filteredPannes = Array.isArray(pannesData)
        ? pannesData.filter(p => !excludedPannes.includes(p.panne || p.name))
        : [];
      setRepairPannes(filteredPannes);
    } catch (err) {
      console.error("Error fetching pannes:", err);
      setRepairPannes([]);
    }
  };

  useEffect(() => {
    console.log('RepairStation - État complet:', {
      userInfo,
      userPosition,
      isRepairStation,
      isConnected,
      serialNumber,
      movementsCache: movementsCache ? Object.keys(movementsCache) : 'empty',
      hasBeenProcessed,
      selectedRepair
    });
    console.log(nextJob)
    setDebugInfo(`
      Station: ${userPosition}
      Connecté: ${isConnected}
      Serial: ${serialNumber}
      Cache: ${movementsCache ? Object.keys(movementsCache).length + ' mouvements' : 'loading'}
      Utilisateur: ${userInfo ? userInfo.user : 'none'}
      Réparation sélectionnée: ${selectedRepair || 'Aucune'}
      Traité: ${hasBeenProcessed ? 'OUI' : 'NON'}
    `);
  }, [userInfo, userPosition, isConnected, serialNumber, movementsCache, hasBeenProcessed, selectedRepair]);

  const getMovementNameById = (movementId) => {
    if (!movementsCache || Object.keys(movementsCache).length === 0) return null;

    for (const [name, id] of Object.entries(movementsCache)) {
      if (id === movementId) return name;
    }
    return null;
  };

  useEffect(() => {
    const resetHourlyCount = () => {
      if (typeof hourCount === 'function') return;
      setHourCount(0);
    };
  
    const now = new Date();
    const msUntilNextHour =
      (60 - now.getMinutes()) * 60 * 1000 -
      now.getSeconds() * 1000 -
      now.getMilliseconds();
  
    const timeoutId = setTimeout(() => {
      resetHourlyCount();
      const intervalId = setInterval(resetHourlyCount, 60 * 60 * 1000);
      return () => clearInterval(intervalId);
    }, msUntilNextHour);
  
    return () => clearTimeout(timeoutId);
  }, [setHourCount]);

  const getFailedTestKeys = (testObj) => {
    if (!testObj?.testTracking) return [];

    let tracking;
    try {
      tracking = typeof testObj.testTracking === 'string'
        ? JSON.parse(testObj.testTracking)
        : testObj.testTracking;
    } catch {
      return [];
    }

    const normalizeStepKey = (step) => {
      if (!step) return null;
      const [word, num] = step.toLowerCase().split(' ');
      return word + num.charAt(0).toUpperCase() + num.slice(1);
    };

    const failureStepKey = normalizeStepKey(tracking.failureStep);
    if (!failureStepKey || !tracking[failureStepKey]) return [];

    const stepObj = tracking[failureStepKey];
    const failedKeys = [];

    const extractKeys = async(obj, prefix = '') => {
      for (const [key, value] of Object.entries(obj)) {
        const fullKey = prefix ? `${prefix}.${key}` : key;

        if(failureStepKey === 'stepFive'){
          const id = testObj.code_ds5_id
          const code = await api.getCode(id)
          console.log('code panne',code.description )
          failedKeys.push(code.description +' ,')
        }
        else if ( failureStepKey === "stepSix" && (value === false )){
          failedKeys.push(fullKey+', ');
        }
        else if (
          (failureStepKey === 'stepOne' && value === true) ||
          (failureStepKey !== 'stepOne' && (value === false || value === null))
        ) {
          failedKeys.push(fullKey+', ');
        }
        
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          extractKeys(value, fullKey);
        }
      }
    };

    extractKeys(stepObj);
    return failedKeys;
  };

  useEffect(() => {
    if (!isConnected || !serialNumber || serialNumber.includes('Error')) {
      console.log('En attente de connexion...');
      setWarning('');
      setCurrentMovementData(null);
      setHasBeenProcessed(false);
      setSelectedRepair('');
      setPanne('');
      setdate('');
      setPanneId(null);
      return;
    }

    if (!movementsCache || Object.keys(movementsCache).length === 0) {
      console.log('En attente du cache des mouvements...');
      return;
    }

    const checkMovementHistory = async () => {
      if (isCheckingRef.current) return;

      isCheckingRef.current = true;
      try {
        console.log(`Vérification historique pour: ${serialNumber}`);
        const data = await api.getCurrentMovement(serialNumber);

        console.log(' Réponse API historique:', data);

        if (!data) {
          setWarning("Controller not in the database - Start with Quick Drift");
          setHasBeenProcessed(false);
          return;
        }
        
        console.log(data.id_nextjob);
        
        // Get panne_id if coming from Repair
        

        if (data && data.id_movement === 1 && (data.id_nextjob === 15 || data.id_nextjob === 9)) {
          const datapanne = await api.getPanne(data.id_movement, data.id_nextjob, serialNumber);
          console.log(datapanne)
          setPanne(datapanne.data[0].Panne_QuickDrift)
          const rawDate = datapanne.data[0].date
          const dateObj = new Date(rawDate);

          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          console.log("date formate", formattedDate)
          setdate(formattedDate);

        } else if (data && (data.id_movement === 5 || data.id_movement === 9) && (data.id_nextjob === 15 || data.id_nextjob === 9)) {
          const datapanne = await api.getPanne(data.id_movement, data.id_nextjob, serialNumber);
          setPanne(datapanne.data[0].Panne)
          const rawDate = datapanne.data[0].date;

          const dateObj = new Date(rawDate);

          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          console.log("date formate", formattedDate)
          setdate(formattedDate);
        }
        else if (data && data.id_movement === 3 && (data.id_nextjob === 15 || data.id_nextjob === 9)){
         const datapanne = await api.getfulltestSession(serialNumber, data.date);
         console.log('this data session :', datapanne)
         console.log("this panne traited",getFailedTestKeys(datapanne))
          setPanne(getFailedTestKeys(datapanne))
          const rawDate = datapanne.startDate;

          const dateObj = new Date(rawDate);

          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          console.log("date formate", formattedDate)

          setdate(formattedDate);
        }
        else if (data && data.id_movement === 9 && data.id_nextjob === 15){
          // Coming from Repair - fetch panne description
          if (data.panne_id) {
            try {
              const panneData = await api.getAllDs5Panne();
              const panne = panneData.find(p => p.id === data.panne_id);
              if (panne) {
                setPanne(panne.panne || panne.name);
              }
            } catch (err) {
              console.error("Error fetching panne:", err);
            }
          }
          const rawDate = data.date;
          const dateObj = new Date(rawDate);
          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          setdate(formattedDate);
        }
        
        const movementName = getMovementNameById(data.id_movement);
        const nextJobName = getMovementNameById(data.id_nextjob);

        const processedData = {
          ...data,
          movement: movementName,
          nextjob: nextJobName,
          id_movement: data.id_movement,
          id_nextjob: data.id_nextjob
        };

        setCurrentMovementData(processedData);

        console.log('Données traitées:', processedData);

        if (processedData.nextjob !== "Dismount" && processedData.nextjob !== "Repair") {
          setWarning(`Next_Job : ${processedData.nextjob || 'Aucun'}`);
          setHasBeenProcessed(false);
          return;
        }

        setWarning('');
        console.log('Manette valide pour Repair Station');

      } catch (err) {
        console.error("Erreur vérification historique:", err);
        if (err.message.includes('404')) {
          setWarning("Controller not in database - Start with Quick Drift");
        } else {
          setWarning("Erreur de vérification de l'historique");
        }
        setHasBeenProcessed(false);
      } finally {
        isCheckingRef.current = false;
      }
    };

    checkMovementHistory();

  }, [isConnected, serialNumber, movementsCache]);

  const saveToDatabase = async (repairType, repairPanneId = null) => {
    if (!userInfo || !userInfo.id) {
      setWarning("Aucun opérateur connecté. Veuillez vous authentifier.");
      return;
    }

    if (!currentMovementData || !movementsCache || Object.keys(movementsCache).length === 0) {
      setWarning("Données manquantes pour l'enregistrement");
      return;
    }

    const nextJobTarget = REPAIR_MAPPING["Dismount"][repairType];
    const movementId = movementsCache["Dismount"];
    const nextJobId = movementsCache[nextJobTarget];

    if (!movementId || !nextJobId) {
      console.error(`IDs non trouvés dans le cache: Repair=${movementId}, ${nextJobTarget}=${nextJobId}`);
      setWarning("Erreur: IDs des mouvements non trouvés");
      return;
    }

    const payload = {
      serial_number: serialNumber,
      operator: userInfo.id,
      tester: "Dismount",
      movement: movementId,
      nextjob: nextJobId,
      Grade: null,
      cause_rebut: repairType === "BER" ? selectedRebut : null,
      panne: repairPanneId ? Number(repairPanneId) : null,
      version: APP_VERSION
    };

    console.log("Payload envoyé à l'API:", payload);

    try {
      setIsSaving(true);
      await api.saveMovement(payload);
      setIsOpenRebut(false);
      setIsOpenRepairModal(false);
      setHourCount(prev => prev + 1)
      setNextJob(nextJobTarget);
      setShowSuccess(true);
      setHasBeenProcessed(true);
      setSelectedRepair(repairType);

      console.log('Enregistrement réussi - Message permanent');

    } catch (err) {
      console.error("Erreur sauvegarde:", err);
      setWarning(`Erreur enregistrement: ${err.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleRepairConfirm = () => {
    setModalError('');
    
    if (!selectedRepairPanneId) {
      setModalError("Veuillez sélectionner un type de panne");
      return;
    }

    saveToDatabase("Repair", selectedRepairPanneId);
  };

  const handleTogglerebut = (item) => {
    setSelectedRebut(prev => {
      if (!prev) {
        return item;
      }

      const list = prev.split("|||");

      if (list.includes(item)) {
        const updated = list.filter(p => p !== item);
        return updated.join("|||");
      } else {
        return [...list, item].join("|||");
      }
    });
  };

  useEffect(() => {
    setShowSuccess(false);
    setNextJob('');
    setCurrentMovementData(null);
    setWarning('');
    setHasBeenProcessed(false);
    setSelectedRepair('');
  }, [serialNumber]);

  return (
    <div className="repair-container">
      {isConnected && isOpenRebut && (
        <div className="overlay">
          <div className="popup">
            <h3>Select rebut cause</h3>

            <div className="checkboxList">
              {causeList.map((item) => (
                <label key={item} className="checkboxItem">
                  <input
                    type="checkbox"
                    checked={selectedRebut && selectedRebut.split("|||").includes(item)}
                    onChange={() => handleTogglerebut(item)}
                  />
                  {` ${item}`}
                </label>
              ))}
            </div>

            <div className='buttonContainer'>
              <button className="cancelBtn" onClick={() => setIsOpenRebut(false)}>Cancel</button>
              <button className="confirmBtn" onClick={() => saveToDatabase("BER")}disabled={!selectedRebut || selectedRebut.trim() === ""}>Confirm</button>
            </div>
          </div>
        </div>
      )}

      {isConnected && isOpenRepairModal && (
        <div className="overlay">
          <div className="popup">
            <h3>Sélectionner le type de panne</h3>
            {modalError && <div className="message error-message modal-error">{modalError}</div>}

            <div className="modal-field">
              <label>Type de panne:</label>
              <select 
                value={selectedRepairPanneId} 
                onChange={e => {
                  setSelectedRepairPanneId(e.target.value);
                  setModalError('');
                }}
              >
                <option value="">-- Choisir une panne --</option>
                {repairPannes.map(p => (
                  <option key={p.id} value={p.id}>{p.panne || p.name}</option>
                ))}
              </select>
            </div>

            <div className='buttonContainer'>
              <button className="cancelBtn" onClick={() => {
                setIsOpenRepairModal(false);
                setSelectedRepairPanneId('');
                setModalError('');
              }}>Cancel</button>
              <button className="confirmBtn" onClick={handleRepairConfirm}>Confirm</button>
            </div>
          </div>
        </div>
      )}

      <Cadance userInfo={userInfo} movementId={15} hourCount={hourcount} />
      <div>
        <div className="repair-header">
          <h1>Dismount</h1>
        </div>

        {!isConnected && (
          <div className="connection-section">
            <div className="disconnected">
              <h1>🔌 Plug in your DualSense controller.</h1>
            </div>
          </div>
        )}
        {isConnected && (
          <div className="connected-section">
            <div className="serial-display">
              <label>Serial number:</label>
              <div className="serial-value">{serialNumber}</div>
               <label>Board Model :</label>
              <div className="serial-value">{BoardModel}</div>
            </div>
            {currentMovementData && (currentMovementData.id_nextjob===15 || currentMovementData.id_nextjob===9) && (
              <div className="panne-container">
                <table className="panne-table">
                  <tbody>
                    <tr>
                      <td>movement</td>
                      <td>{currentMovementData.movement}</td>
                    </tr>
                    <tr>
                      <th>Panne</th>
                      <td>{Panne}</td>
                    </tr>
                    <tr>
                      <td>date</td>
                      <td>{date}</td>
                    </tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            )}
            {warning && (
              <div className="message warning-message">
                {warning}
              </div>
            )}

            {isSaving && (
              <div className="message waiting-message">
                Enregistrement en cours...
              </div>
            )}

            {showSuccess && nextJob && (
              <div className="message success-message permanent">
                <div className="success-details">
                  <div><strong>Next Job:</strong> <span className="next-job">{nextJob}</span></div>
                  <div><strong>Type de réparation:</strong> <span className="repair-type">
                    {selectedRepair === "Repair"
                      ? "Repair"
                      : selectedRepair === "joystick"
                        ? "Repair Joystick"
                        : "BER"}
                  </span></div>
                </div>
              </div>
            )}

            {!hasBeenProcessed && currentMovementData && (currentMovementData.nextjob === "Dismount"|| currentMovementData.nextjob === "Repair") &&
              !isSaving && !showSuccess && userInfo && (
                <div className="repair-buttons-section">
                  <div className="repair-buttons-row">
                    <button
                      onClick={() => {
                        getRepairPannes();
                        setIsOpenRepairModal(true);
                      }}
                      disabled={isSaving}
                      className={`btn-repair btn-battery ${selectedRepair === "Repair" ? "selected" : ""}`}
                    >
                      {isSaving && selectedRepair === "Repair" ? '⏳...' : 'Repair'}
                    </button>

                    <button
                      onClick={() => saveToDatabase("joystick")}
                      disabled={isSaving}
                      className={`btn-repair btn-joystick ${selectedRepair === "joystick" ? "selected" : ""}`}
                    >
                      {isSaving && selectedRepair === "joystick" ? '⏳...' : 'Repair Joystick'}
                    </button>
                    <button
                      onClick={() => {
                        getRebut();
                        setIsOpenRebut(true);
                      }}
                      disabled={isSaving}
                      className={`btn-repair btn-depanage ${selectedRepair === "BER" ? "selected" : ""}`}
                    >
                      {isSaving && selectedRepair === "BER" ? '⏳...' : 'BER'}
                    </button>
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RepairStation;